import { X } from "lucide-react";
import type { ReactNode } from "react";

interface ModalProps {
  title: string;
  children: ReactNode;
  onClose: () => void;
  wide?: boolean;
  className?: string;
}

export function Modal({ title, children, onClose, wide, className }: ModalProps) {
  const modalClassName = ["modal", wide ? "wide" : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className={modalClassName}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="icon-button" onClick={onClose} aria-label="關閉"><X size={16} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}
